// Module
var code = "<svg :aria-hidden=\"isHidden\" :aria-label=\"ariaLabel\" fill=\"currentColor\" class=\"inline-block\" :height=\"size\" viewBox=\"0 0 24 24\"> <path :d=\"path\" v-for=\"path in paths[name]\"/> </svg> ";
// Exports
export default code;